import React from 'react';
import { Instagram, Mail, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-dark text-gray-400 py-8 md:py-12 px-4 border-t border-white/10" data-id="element-154">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-155">
        <div className="mb-6 md:mb-8" data-id="element-156">
          <h2 className="text-xl md:text-2xl font-black text-white mb-2 flex items-center justify-center gap-2" data-id="element-157">
            ⚽ FÚTBOL FEMENINO RESUELTO™
          </h2>
          <p className="max-w-md mx-auto text-xs md:text-sm" data-id="element-158">
            El sistema completo N°1 para entrenadores de fútbol femenino en
            Argentina. Porque entrenar fútbol femenino no debería costarte todas
            las noches de la semana.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 mb-8 md:mb-12 text-sm md:text-base" data-id="element-159">
          <a href="mailto:contacto@fitnessresuelto.shop" className="flex items-center gap-2 hover:text-brandGreen transition-colors" data-id="element-160">
            <Mail className="w-4 h-4 md:w-5 md:h-5" data-id="element-161" />
            contacto@fitnessresuelto.shop
          </a>
          <a href="#" className="flex items-center gap-2 hover:text-brandGreen transition-colors" data-id="element-162">
            @recursosfitness.ar
          </a>
          <a href="#" className="flex items-center gap-2 hover:text-brandGreen transition-colors" data-id="element-163">
            recursosfitness.shop
          </a>
        </div>

        <div className="text-[10px] md:text-xs border-t border-white/10 pt-6 md:pt-8 w-full" data-id="element-164">
          <p data-id="element-165">
            © fitnessresuelto.shop™ 2026 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}